/**
 * Reports Module Routes Configuration
 *
 * Shared report routes. Mounted by whichever module needs them —
 * currently ds-wms at /app/ds-wms/reports/*.
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

// Lazy load page components
const ReportsListPage = lazy(() => import('../pages/ReportsList'));
const ReportDetailPage = lazy(() => import('../pages/ReportDetail'));

/**
 * Reports routes configuration
 * Mounted as a child route by the consuming module.
 */
export const reportsRoutes: RouteObject[] = [
  {
    index: true,
    element: <ReportsListPage />
  },
  {
    path: ':id',
    element: <ReportDetailPage />
  }
];

export default reportsRoutes;
